// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__3NGNLu8W","loader":"Loader_loader__8lu9eiKB"};